module.exports = __webpack_public_path__ + "static/media/move1.765f05a0.JPG";